import { useState } from "react";
import { Link } from "react-router-dom";

const Account = () => {

    const [loginVisible, setLoginVisible] = useState(false);
    const [registerVisible, setRegisterVisible] = useState(false);
    const [retypeVisible, setRetypeVisible] = useState(false);

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Login / Sign up</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="account-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-6 login">
                            <div className="form">
                                <h5>Login Your Account</h5>
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="User Name"
                                        required
                                    />
                                </div>
                                <div className="position-relative">
                                    <input
                                        type={loginVisible ? "text" : "password"}
                                        id="login-password"
                                        name="password"
                                        placeholder="Password"
                                        required
                                    />
                                    <span
                                        className="toggle-password"
                                        onClick={() => setLoginVisible(!loginVisible)}
                                    >
                                        <i
                                            className={`fa-solid ${loginVisible ? "fa-eye-slash" : "fa-eye"
                                                }`}
                                        />
                                    </span>
                                </div>
                                <div className="position-relative">
                                    <button type="submit" id="login">
                                        LOG In
                                    </button>
                                </div>
                                <div className="forget">
                                    <div className="form-check d-flex remember">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            defaultValue
                                            id="rememberMe"
                                        />
                                        <label className="form-check-label" htmlFor="rememberMe">
                                            Remember Me
                                        </label>
                                    </div>
                                    <Link to="#" className="bnts">
                                        Forget Password
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 signin">
                            <div className="form">
                                <h5>Register Your Account</h5>
                                <div className="row fomrs">
                                    <div className="col-md-6 col-lg-6">
                                        <div className="position-relative">
                                            <input type="text" id="fname" placeholder="First Name" />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6">
                                        <div className="position-relative">
                                            <input type="text" id="lname" placeholder="Last Name" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row fomrs">
                                    <div className="col-12">
                                        <div className="position-relative">
                                            <input
                                                type="email"
                                                placeholder="Email Address"
                                                id="email"
                                                name="email"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row fomrs">
                                    <div className="col-12">
                                        <div className="position-relative">
                                            <input
                                                type={registerVisible ? "text" : "password"}
                                                id="register-password"
                                                name="password"
                                                placeholder="Enter Password"
                                                required
                                            />
                                            <span
                                                className="toggle-password"
                                                onClick={() =>
                                                    setRegisterVisible(!registerVisible)
                                                }
                                            >
                                                <i
                                                    className={`fa-solid ${registerVisible ? "fa-eye-slash" : "fa-eye"
                                                        }`}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row fomrs">
                                    <div className="col-12">
                                        <div className="position-relative">
                                            <input
                                                type={retypeVisible ? "text" : "password"}
                                                id="rpassword"
                                                name="rpassword"
                                                placeholder="Retype Password"
                                                required
                                            />
                                            <span
                                                className="toggle-password"
                                                onClick={() => setRetypeVisible(!retypeVisible)}
                                            >
                                                <i
                                                    className={`fa-solid ${retypeVisible ? "fa-eye-slash" : "fa-eye"
                                                        }`}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row fomrs">
                                    <div className="col-12 para">
                                        <p>
                                            By creating an account, you agree to our{" "}
                                            <Link to="#">Term &amp; Conditions</Link>
                                        </p>
                                    </div>
                                </div>
                                <button type="submit" id="signin">
                                    CREATE ACCOUNT
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Account